"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollOffPricingSnapshot = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const fee_1 = require("./fee");
const roll_off_material_price_matrix_1 = require("./roll-off-material-price-matrix");
exports.RollOffPricingSnapshot = typebox_1.Type.Object({
    zoneID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    customPricingID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    materialID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    material: common_1.Material,
    sizeData: roll_off_material_price_matrix_1.RollOffSizePriceMatrix,
    type: common_1.RollOffPricingType,
    rentalPeriod: typebox_1.Type.Optional(common_1.Duration),
    rentalExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Number()),
    pricingFees: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Pick(fee_1.PricingFee, [
        'id',
        'amount',
        'whereToApply',
        'name',
        'taxable',
        'howToApply',
        'forPaymentMethod',
        'type',
        'paymentFeeFixedAmount',
    ]))),
    /**
     * Used for hauler pricing snapshots only currently
     */
    paymentTerm: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    /**
     * Used for hauler pricing snapshots only currently
     */
    paymentMethod: typebox_1.Type.Optional(common_1.PaymentMethod),
});
//# sourceMappingURL=roll-off-pricing-snapshot.js.map